import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { RoleSysPackages } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { NotFoundPage } from '../../../../page/not-found'
import { PackagesList } from './packages-list'
import { PackagePage } from './package-page'
import { VersionPage } from './version-page'

// /admin/packages: EducationXR's Unity package registry for staff: the list,
// /admin/packages/:name (versions and publish keys) and
// /admin/packages/:name/:channel/:version. The route itself is gated by
// SYS_PACKAGES read (not only its sidebar entry), so a typed address without
// it says so instead of a page whose every read is refused; an address under
// it that is no page is the app's not-found page.
export const LayoutPackages = () =>
  <Route path="/admin/packages">
    <RoleSysPackages accessRead fallback={<NoAccess what="Packages" />}>
      <Switch>
        <Route exact path="/admin/packages" component={PackagesList} />
        <Route exact path="/admin/packages/:name" component={PackagePage} />
        <Route exact path="/admin/packages/:name/:channel/:version" component={VersionPage} />
        <Route render={({ location }) => <NotFoundPage pathname={location.pathname} />} />
      </Switch>
    </RoleSysPackages>
  </Route>
